import axios from 'axios'

export const getTopicKeyword = async (id_project) => {
    let url = process.env.VUE_APP_API_URL + 'topic-keyword/' + id_project
    const response = await axios.get(url);
    return response.data;
};